/**
 * Generated by orval v8.4.2 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { useMutation, useQuery } from "@tanstack/react-query";

import type {
  BadRequestResponse,
  CompleteFtue200,
  ConfirmLogoUpload200,
  ConfirmLogoUploadBody,
  CreateOrganization200,
  CreateOrganizationBody,
  DeleteExternalApiKey200,
  ForbiddenResponse,
  GenerateExternalApiKey200,
  GenerateExternalApiKeyBody,
  GetExternalApiKey200,
  GetLogoPresignedUrl200,
  GetLogoPresignedUrlBody,
  GetOrganization200,
  GetOrganizationSettings200,
  InternalServerErrorResponse,
  NotFoundResponse,
  Organization,
  UnauthorizedResponse,
  UpdateOrganization200,
  UpdateOrganizationBody,
  UpdateOrganizationSettings200,
  UpdateOrganizationSettingsBody,
} from ".././model";

import { customInstance } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Get organization details
 */
export const getOrganization = (
  organizationId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetOrganization200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetOrganizationQueryKey = (organizationId: string) => {
  return [`https://api.app.usesky.ai/organizations/${organizationId}`] as const;
};

export const getGetOrganizationQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganization>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganization>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOrganizationQueryKey(organizationId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganization>>> = ({
    signal,
  }) => getOrganization(organizationId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!organizationId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganization>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganization>>
>;
export type GetOrganizationQueryError =
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetOrganization<
  TData = Awaited<ReturnType<typeof getOrganization>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganization>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganization>>,
          TError,
          Awaited<ReturnType<typeof getOrganization>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrganization<
  TData = Awaited<ReturnType<typeof getOrganization>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganization>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganization>>,
          TError,
          Awaited<ReturnType<typeof getOrganization>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrganization<
  TData = Awaited<ReturnType<typeof getOrganization>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganization>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get organization details
 */

export function useGetOrganization<
  TData = Awaited<ReturnType<typeof getOrganization>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganization>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOrganizationQueryOptions(organizationId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update organization details
 */
export const updateOrganization = (
  organizationId: string,
  updateOrganizationBody: UpdateOrganizationBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<UpdateOrganization200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateOrganizationBody,
      signal,
    },
    options
  );
};

export const getUpdateOrganizationMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrganization>>,
    TError,
    { organizationId: string; data: UpdateOrganizationBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOrganization>>,
  TError,
  { organizationId: string; data: UpdateOrganizationBody },
  TContext
> => {
  const mutationKey = ["updateOrganization"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOrganization>>,
    { organizationId: string; data: UpdateOrganizationBody }
  > = (props) => {
    const { organizationId, data } = props ?? {};

    return updateOrganization(organizationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOrganization>>
>;
export type UpdateOrganizationMutationBody = UpdateOrganizationBody;
export type UpdateOrganizationMutationError = unknown;

/**
 * @summary Update organization details
 */
export const useUpdateOrganization = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateOrganization>>,
      TError,
      { organizationId: string; data: UpdateOrganizationBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateOrganization>>,
  TError,
  { organizationId: string; data: UpdateOrganizationBody },
  TContext
> => {
  return useMutation(
    getUpdateOrganizationMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Get presigned URL for organization logo upload
 */
export const getLogoPresignedUrl = (
  organizationId: string,
  getLogoPresignedUrlBody: GetLogoPresignedUrlBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetLogoPresignedUrl200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/logo/presigned-url`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getLogoPresignedUrlBody,
      signal,
    },
    options
  );
};

export const getGetLogoPresignedUrlMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getLogoPresignedUrl>>,
    TError,
    { organizationId: string; data: GetLogoPresignedUrlBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getLogoPresignedUrl>>,
  TError,
  { organizationId: string; data: GetLogoPresignedUrlBody },
  TContext
> => {
  const mutationKey = ["getLogoPresignedUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getLogoPresignedUrl>>,
    { organizationId: string; data: GetLogoPresignedUrlBody }
  > = (props) => {
    const { organizationId, data } = props ?? {};

    return getLogoPresignedUrl(organizationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetLogoPresignedUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof getLogoPresignedUrl>>
>;
export type GetLogoPresignedUrlMutationBody = GetLogoPresignedUrlBody;
export type GetLogoPresignedUrlMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Get presigned URL for organization logo upload
 */
export const useGetLogoPresignedUrl = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getLogoPresignedUrl>>,
      TError,
      { organizationId: string; data: GetLogoPresignedUrlBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof getLogoPresignedUrl>>,
  TError,
  { organizationId: string; data: GetLogoPresignedUrlBody },
  TContext
> => {
  return useMutation(
    getGetLogoPresignedUrlMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Confirm logo upload and update organization
 */
export const confirmLogoUpload = (
  organizationId: string,
  confirmLogoUploadBody: ConfirmLogoUploadBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ConfirmLogoUpload200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/logo/confirm`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: confirmLogoUploadBody,
      signal,
    },
    options
  );
};

export const getConfirmLogoUploadMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmLogoUpload>>,
    TError,
    { organizationId: string; data: ConfirmLogoUploadBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmLogoUpload>>,
  TError,
  { organizationId: string; data: ConfirmLogoUploadBody },
  TContext
> => {
  const mutationKey = ["confirmLogoUpload"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmLogoUpload>>,
    { organizationId: string; data: ConfirmLogoUploadBody }
  > = (props) => {
    const { organizationId, data } = props ?? {};

    return confirmLogoUpload(organizationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfirmLogoUploadMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmLogoUpload>>
>;
export type ConfirmLogoUploadMutationBody = ConfirmLogoUploadBody;
export type ConfirmLogoUploadMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Confirm logo upload and update organization
 */
export const useConfirmLogoUpload = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof confirmLogoUpload>>,
      TError,
      { organizationId: string; data: ConfirmLogoUploadBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof confirmLogoUpload>>,
  TError,
  { organizationId: string; data: ConfirmLogoUploadBody },
  TContext
> => {
  return useMutation(getConfirmLogoUploadMutationOptions(options), queryClient);
};
/**
 * @summary Get organization settings (logo, font, line spacing, footnote)
 */
export const getOrganizationSettings = (
  organizationId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetOrganizationSettings200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/settings`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetOrganizationSettingsQueryKey = (organizationId: string) => {
  return [
    `https://api.app.usesky.ai/organizations/${organizationId}/settings`,
  ] as const;
};

export const getGetOrganizationSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationSettings>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationSettings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetOrganizationSettingsQueryKey(organizationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOrganizationSettings>>
  > = ({ signal }) =>
    getOrganizationSettings(organizationId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!organizationId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationSettings>>
>;
export type GetOrganizationSettingsQueryError =
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetOrganizationSettings<
  TData = Awaited<ReturnType<typeof getOrganizationSettings>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationSettings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationSettings>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationSettings>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrganizationSettings<
  TData = Awaited<ReturnType<typeof getOrganizationSettings>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationSettings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationSettings>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationSettings>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrganizationSettings<
  TData = Awaited<ReturnType<typeof getOrganizationSettings>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationSettings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get organization settings (logo, font, line spacing, footnote)
 */

export function useGetOrganizationSettings<
  TData = Awaited<ReturnType<typeof getOrganizationSettings>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationSettings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOrganizationSettingsQueryOptions(
    organizationId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update organization settings (logo, font, line spacing, footnote)
 */
export const updateOrganizationSettings = (
  organizationId: string,
  updateOrganizationSettingsBody: UpdateOrganizationSettingsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<UpdateOrganizationSettings200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/settings`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateOrganizationSettingsBody,
      signal,
    },
    options
  );
};

export const getUpdateOrganizationSettingsMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrganizationSettings>>,
    TError,
    { organizationId: string; data: UpdateOrganizationSettingsBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOrganizationSettings>>,
  TError,
  { organizationId: string; data: UpdateOrganizationSettingsBody },
  TContext
> => {
  const mutationKey = ["updateOrganizationSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOrganizationSettings>>,
    { organizationId: string; data: UpdateOrganizationSettingsBody }
  > = (props) => {
    const { organizationId, data } = props ?? {};

    return updateOrganizationSettings(organizationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOrganizationSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOrganizationSettings>>
>;
export type UpdateOrganizationSettingsMutationBody =
  UpdateOrganizationSettingsBody;
export type UpdateOrganizationSettingsMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Update organization settings (logo, font, line spacing, footnote)
 */
export const useUpdateOrganizationSettings = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateOrganizationSettings>>,
      TError,
      { organizationId: string; data: UpdateOrganizationSettingsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateOrganizationSettings>>,
  TError,
  { organizationId: string; data: UpdateOrganizationSettingsBody },
  TContext
> => {
  return useMutation(
    getUpdateOrganizationSettingsMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Returns the list of organizations for the current user
 */
export const listOrganizations = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<Organization[]>(
    { url: `https://api.app.usesky.ai/organizations`, method: "GET", signal },
    options
  );
};

export const getListOrganizationsQueryKey = () => {
  return [`https://api.app.usesky.ai/organizations`] as const;
};

export const getListOrganizationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listOrganizations>>,
  TError = UnauthorizedResponse | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listOrganizations>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListOrganizationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOrganizations>>
  > = ({ signal }) => listOrganizations(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listOrganizations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListOrganizationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOrganizations>>
>;
export type ListOrganizationsQueryError =
  | UnauthorizedResponse
  | InternalServerErrorResponse;

export function useListOrganizations<
  TData = Awaited<ReturnType<typeof listOrganizations>>,
  TError = UnauthorizedResponse | InternalServerErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizations>>,
          TError,
          Awaited<ReturnType<typeof listOrganizations>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOrganizations<
  TData = Awaited<ReturnType<typeof listOrganizations>>,
  TError = UnauthorizedResponse | InternalServerErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizations>>,
          TError,
          Awaited<ReturnType<typeof listOrganizations>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOrganizations<
  TData = Awaited<ReturnType<typeof listOrganizations>>,
  TError = UnauthorizedResponse | InternalServerErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Returns the list of organizations for the current user
 */

export function useListOrganizations<
  TData = Awaited<ReturnType<typeof listOrganizations>>,
  TError = UnauthorizedResponse | InternalServerErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListOrganizationsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Creates a new organization, including:
- Creating an owner user in Cognito and database
- Creating a support user in Cognito and database
- Creating the organization in the database
- Creating standard document categories

 * @summary Creates a new organization with an owner and support
 */
export const createOrganization = (
  createOrganizationBody: CreateOrganizationBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CreateOrganization200>(
    {
      url: `https://api.app.usesky.ai/organizations/create`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createOrganizationBody,
      signal,
    },
    options
  );
};

export const getCreateOrganizationMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrganization>>,
    TError,
    { data: CreateOrganizationBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOrganization>>,
  TError,
  { data: CreateOrganizationBody },
  TContext
> => {
  const mutationKey = ["createOrganization"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOrganization>>,
    { data: CreateOrganizationBody }
  > = (props) => {
    const { data } = props ?? {};

    return createOrganization(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOrganization>>
>;
export type CreateOrganizationMutationBody = CreateOrganizationBody;
export type CreateOrganizationMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

/**
 * @summary Creates a new organization with an owner and support
 */
export const useCreateOrganization = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createOrganization>>,
      TError,
      { data: CreateOrganizationBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createOrganization>>,
  TError,
  { data: CreateOrganizationBody },
  TContext
> => {
  return useMutation(
    getCreateOrganizationMutationOptions(options),
    queryClient
  );
};
/**
 * Get all active API keys for an organization
 * @summary Get organization API keys
 */
export const getExternalApiKey = (
  organizationId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetExternalApiKey200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/external-api/key`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetExternalApiKeyQueryKey = (organizationId: string) => {
  return [
    `https://api.app.usesky.ai/organizations/${organizationId}/external-api/key`,
  ] as const;
};

export const getGetExternalApiKeyQueryOptions = <
  TData = Awaited<ReturnType<typeof getExternalApiKey>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExternalApiKey>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetExternalApiKeyQueryKey(organizationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getExternalApiKey>>
  > = ({ signal }) => getExternalApiKey(organizationId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!organizationId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getExternalApiKey>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetExternalApiKeyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getExternalApiKey>>
>;
export type GetExternalApiKeyQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetExternalApiKey<
  TData = Awaited<ReturnType<typeof getExternalApiKey>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExternalApiKey>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExternalApiKey>>,
          TError,
          Awaited<ReturnType<typeof getExternalApiKey>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExternalApiKey<
  TData = Awaited<ReturnType<typeof getExternalApiKey>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExternalApiKey>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExternalApiKey>>,
          TError,
          Awaited<ReturnType<typeof getExternalApiKey>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExternalApiKey<
  TData = Awaited<ReturnType<typeof getExternalApiKey>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExternalApiKey>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get organization API keys
 */

export function useGetExternalApiKey<
  TData = Awaited<ReturnType<typeof getExternalApiKey>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExternalApiKey>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetExternalApiKeyQueryOptions(
    organizationId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Generate a new API key for an organization. The full API key is only returned once upon creation.
 * @summary Generate a new API key
 */
export const generateExternalApiKey = (
  organizationId: string,
  generateExternalApiKeyBody: GenerateExternalApiKeyBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GenerateExternalApiKey200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/external-api/key`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: generateExternalApiKeyBody,
      signal,
    },
    options
  );
};

export const getGenerateExternalApiKeyMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateExternalApiKey>>,
    TError,
    { organizationId: string; data: GenerateExternalApiKeyBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateExternalApiKey>>,
  TError,
  { organizationId: string; data: GenerateExternalApiKeyBody },
  TContext
> => {
  const mutationKey = ["generateExternalApiKey"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateExternalApiKey>>,
    { organizationId: string; data: GenerateExternalApiKeyBody }
  > = (props) => {
    const { organizationId, data } = props ?? {};

    return generateExternalApiKey(organizationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateExternalApiKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateExternalApiKey>>
>;
export type GenerateExternalApiKeyMutationBody = GenerateExternalApiKeyBody;
export type GenerateExternalApiKeyMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Generate a new API key
 */
export const useGenerateExternalApiKey = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof generateExternalApiKey>>,
      TError,
      { organizationId: string; data: GenerateExternalApiKeyBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof generateExternalApiKey>>,
  TError,
  { organizationId: string; data: GenerateExternalApiKeyBody },
  TContext
> => {
  return useMutation(
    getGenerateExternalApiKeyMutationOptions(options),
    queryClient
  );
};
/**
 * Soft delete an API key by setting it as inactive and recording deletion timestamp. The API key cannot be used after deletion.
 * @summary Delete organization API key
 */
export const deleteExternalApiKey = (
  organizationId: string,
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<DeleteExternalApiKey200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/external-api/key/${id}`,
      method: "DELETE",
      signal,
    },
    options
  );
};

export const getDeleteExternalApiKeyMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteExternalApiKey>>,
    TError,
    { organizationId: string; id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteExternalApiKey>>,
  TError,
  { organizationId: string; id: string },
  TContext
> => {
  const mutationKey = ["deleteExternalApiKey"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteExternalApiKey>>,
    { organizationId: string; id: string }
  > = (props) => {
    const { organizationId, id } = props ?? {};

    return deleteExternalApiKey(organizationId, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteExternalApiKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteExternalApiKey>>
>;

export type DeleteExternalApiKeyMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Delete organization API key
 */
export const useDeleteExternalApiKey = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteExternalApiKey>>,
      TError,
      { organizationId: string; id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteExternalApiKey>>,
  TError,
  { organizationId: string; id: string },
  TContext
> => {
  return useMutation(
    getDeleteExternalApiKeyMutationOptions(options),
    queryClient
  );
};
/**
 * Updates the user's hasCompletedFtue flag to true and sets ftueCompletedAt timestamp
 * @summary Mark the current user's FTUE as complete
 */
export const completeFtue = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CompleteFtue200>(
    {
      url: `https://api.app.usesky.ai/organizations/complete-ftue`,
      method: "PATCH",
      signal,
    },
    options
  );
};

export const getCompleteFtueMutationOptions = <
  TError = UnauthorizedResponse | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeFtue>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeFtue>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["completeFtue"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeFtue>>,
    void
  > = () => {
    return completeFtue(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteFtueMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeFtue>>
>;

export type CompleteFtueMutationError =
  | UnauthorizedResponse
  | InternalServerErrorResponse;

/**
 * @summary Mark the current user's FTUE as complete
 */
export const useCompleteFtue = <
  TError = UnauthorizedResponse | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof completeFtue>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof completeFtue>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getCompleteFtueMutationOptions(options), queryClient);
};
